import { ICertificateType } from '@aca-new/app/pages/book/pages/food-certification/shared/models/interfaces/food-certification-order.interface';
import { IBookFromPreviousTableStrategy } from '@aca-new/app/pages/bookings/pages/previous-order-item/shared/interfaces/book-from-previous-table-strategy.interface';
import { IDataTableQueryParams } from '@aca-new/app/shared/components/data-table/shared/models/interfaces/data-table-query-params.interface';
import { LabelWithTooltipCellComponent } from '@aca-new/app/shared/components/table/shared/components/common-table-cell/shared/label-with-tooltip-cell/label-with-tooltip-cell.component';
import { ETableDataType } from '@aca-new/app/shared/components/table/shared/enums/table-data-type.enum';
import { ITableBodyCell } from '@aca-new/app/shared/components/table/shared/interfaces/table-data.interface';
import { ITableHeader } from '@aca-new/app/shared/components/table/shared/interfaces/table-header.interface';
import { SERVER_URL } from '@aca-new/app/shared/constants/app.constants';
import { AUDIT_DATE, REF_NO, SERVICE_TYPE } from '@aca-new/app/shared/constants/table-header.constants';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { Injectable } from '@angular/core';
import { EQimaTableHeadCellSort } from '@qima/ngx-qima';
import { assign, cloneDeep, pickBy } from 'lodash/index';

@Injectable()
export class FoodCertificationTableStrategyService implements IBookFromPreviousTableStrategy {
  public readonly userId: string = this._storageService.getItem(EStorageKeys.USER_ID);
  public tableUrlPath: string = `${SERVER_URL}/user/${this.userId}/wqs/orders`;

  public tableHeaders: ITableHeader[] = [
    assign(cloneDeep(SERVICE_TYPE), { key: 'serviceType' }),
    assign(cloneDeep(REF_NO), { key: 'refNumber', width: '190', sortKey: 'refNumber' }),
    assign(cloneDeep(AUDIT_DATE), { key: 'auditDateFrom', sortKey: 'auditDateFrom', width: '205' }),
    {
      label: 'BOOKS.FOOD_CERTIFICATION.CERTIFICATION_TYPE',
      type: ETableDataType.CUSTOMIZED,
      width: '130',
      cellTransform(cellData: ITableBodyCell, pageItem): void {
        const certTypeTextList = ((pageItem?.certificateTypes || []) as ICertificateType[]).map((type): string => type.certTypeText);

        cellData.customizedCellConfiguration = {
          component: LabelWithTooltipCellComponent,
          data: {
            hoverSize: certTypeTextList.length > 1 ? certTypeTextList.length - 1 : 0,
            restText: certTypeTextList.length > 1 ? certTypeTextList.slice(1) : [],
            value: certTypeTextList.length > 0 ? certTypeTextList[0] : '',
          },
        };
      },
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      key: 'announcementType',
      label: 'BOOKS.FOOD_CERTIFICATION.ANNOUNCEMENT_TYPE',
      type: ETableDataType.STRING,
      width: '100',
    },
    {
      sortType: EQimaTableHeadCellSort.ALPHABETICALLY,
      key: 'producerLegalEntity',
      label: 'APP_ASIDE.COMMON_ITEMS.PRODUCERS',
      type: ETableDataType.STRING,
      width: '100',
    },
  ];

  public constructor(protected readonly _storageService: StorageService) {}

  public getTableUrlParams(tableParams: IDataTableQueryParams): Record<string, string> {
    return pickBy({
      'status': 220,
      'isRecert': 'true',
      'keyword': tableParams.keyword,
      'page-size': tableParams.pageSize.toString(), // eslint-disable-line @typescript-eslint/naming-convention
      'pageNumber': tableParams.page.toString(),
      'sortType': tableParams.sortType,
      'sortField': tableParams.sortField || 'auditDateFrom',
    }) as Record<string, string>;
  }
}
